<div class="timesheet-detail-group">
  <div *subscriptionPlan="planType.BASIC" class="timesheet-detail-group__info">
    <shift-warning
      [absenceWarning]="absenceWarning || hasAbsenceConflict"
      [doubleRegistration]="doubleRegistration || hasTimesheetConflict"
    ></shift-warning>
  </div>

  <div class="timesheet-detail-group__info">
    @if (!cols?.break && timesheet.break > 0) {
      <ng-template #breakTooltip> {{ 'Break' | translate }}: {{ timesheet.break }} </ng-template>
      <sb-badge [size]="'large'" [color]="'red'" [sbTooltip]="breakTooltip" class="mr-1 truncate last:mr-0">
        <sb-icon class="button-icon__icon" name="teacup-regular" />&nbsp;{{ timesheet.break }}
      </sb-badge>
    }

    @if (!cols?.location && timesheet.location_name != timesheet.department_name && !!timesheet.location_name) {
      <ng-template #locationTooltip> {{ 'Location' | translate }}: {{ timesheet.location_name }} </ng-template>
      <sb-badge
        [size]="'large'"
        [color]="'indigo'"
        [sbTooltip]="locationTooltip"
        class="mr-1 max-w-20 truncate last:mr-0"
      >
        {{ timesheet.location_name }}
      </sb-badge>
    }

    @if (!cols?.department && !!timesheet.department_name) {
      <ng-template #departmentTooltip> {{ 'Department' | translate }}: {{ timesheet.department_name }} </ng-template>
      <sb-badge
        [size]="'large'"
        [color]="'cyan'"
        [sbTooltip]="departmentTooltip"
        class="mr-1 max-w-20 truncate last:mr-0"
      >
        {{ timesheet.department_name }}
      </sb-badge>
    }

    @if (!cols?.team) {
      <ng-template #teamTooltip> {{ 'Team' | translate }}: {{ timesheet.Team.name }} </ng-template>
      <sb-badge
        [size]="'large'"
        [color]="'greenLight'"
        [sbTooltip]="teamTooltip"
        class="mr-1 max-w-20 truncate last:mr-0"
      >
        {{ timesheet.Team.name }}
      </sb-badge>
    }

    @if (!cols?.shift) {
      <ng-template #shiftTooltip> {{ 'Shift' | translate }}: {{ timesheet.Shift.long_name }} </ng-template>
      <sb-badge [size]="'large'" [color]="'pink'" [sbTooltip]="shiftTooltip" class="mr-1 max-w-20 truncate last:mr-0">
        {{ timesheet.Shift.long_name }}
      </sb-badge>
    }

    <ng-container *subscriptionPlan="planType.BASIC">
      @if (timesheet.clock) {
        <ng-template #clockTimesTooltip>
          @if (!!timesheet.clocked_in) {
            <div>
              {{ 'Clocked in' | translate }}: {{ timesheet.clocked_in | localeDate: 'timeSeconds' }}
              @if (timesheet.ClockedInOrigin) {
                {{ 'via' | translate }} {{ timesheet.ClockedInOrigin }}
              }
            </div>
          }

          @if (timesheet.ClockBreak?.length > 0) {
            @for (clockBreak of timesheet.ClockBreak; track clockBreak) {
              <div>
                {{ 'Break' | translate }}: {{ clockBreak.clocked_in | localeDate: 'timeSeconds' }} -
                {{ clockBreak.clocked_out | localeDate: 'timeSeconds' }}
              </div>
            }
            <div>{{ 'Total break' | translate }}: {{ formattedBreakTime() }}</div>
          }

          @if (timesheet.clocked_out) {
            <div>
              {{ 'Clocked out' | translate }}: {{ timesheet.clocked_out | localeDate: 'timeSeconds' }}
              @if (timesheet.ClockedOutOrigin) {
                {{ 'via' | translate }} {{ timesheet.ClockedOutOrigin }}
              }
            </div>
          }
        </ng-template>

        <sb-badge
          data-testid="timesheet-clock-badge"
          [size]="'large'"
          [color]="'grey'"
          [sbTooltip]="clockTimesTooltip"
          [sbTooltipDisabled]="!timesheet.canViewClockTime"
          class="mr-1 truncate last:mr-0"
          (click)="showClockMap()"
        >
          <sb-icon class="button-icon__icon" name="stopwatch-regular" />
        </sb-badge>
      }
    </ng-container>

    @if (!cols?.note && !!timesheet.note) {
      <sb-badge [size]="'large'" color="brand" [sbTooltip]="timesheet.note" class="mr-1 last:mr-0">
        <sb-icon class="button-icon__icon" name="chat-1-regular" />
      </sb-badge>
    }

    @if (timesheet.Shift.is_task) {
      <sb-badge
        [size]="'large'"
        color="brand"
        [sbTooltip]="'This timesheet belongs to a task: [task]' | translate: { task: timesheet.Shift.long_name }"
        class="mr-1 last:mr-0"
      >
        <sb-icon class="button-icon__icon" name="task-2-regular" />
      </sb-badge>
    }

    <ng-container *subscriptionPlan="planType.PREMIUM">
      @if (!cols?.km && timesheet.kilometers > 0) {
        <ng-template #kmTooltip> {{ 'Kilometers' | translate }}: {{ timesheet.kilometers | decimal }} </ng-template>
        <sb-badge [size]="'large'" [color]="'purple'" [sbTooltip]="kmTooltip" class="mr-1 last:mr-0">
          <sb-icon class="button-icon__icon" name="car-regular" />&nbsp;{{ timesheet.kilometers | decimal }}
        </sb-badge>
      }

      @if (!cols?.meals && timesheet.meals > 0) {
        <ng-template #mealTooltip> {{ 'Meals' | translate }}: {{ timesheet.meals }} </ng-template>
        <sb-badge [size]="'large'" [color]="'yellow'" [sbTooltip]="mealTooltip" class="mr-1 last:mr-0">
          <sb-icon class="button-icon__icon" name="fork-knife-regular" />&nbsp;{{ timesheet.meals }}
        </sb-badge>
      }
    </ng-container>

    <ng-container *subscriptionPlan="planType.BASIC">
      @if (
        ((timesheet.Rates?.surcharge_pay !== 0 || timesheet.Rates?.surcharge_time !== 0) && hasRateCard) ||
        (timesheet.overtimeHour && timesheet.overtimeHour !== 0) ||
        (timesheet.overtimeMinutes && timesheet.overtimeMinutes !== 0)
      ) {
        <ng-template #surchargeTooltip>
          <div>
            @if (!timesheet.RateCard?.deleted && hasRateCard) {
              <ng-container class="block"> {{ 'Rate card' | translate }}: {{ timesheet.RateCard?.name }} </ng-container>
            }
            @if (timesheet.RateCard?.deleted) {
              <ng-container class="block">
                {{ '[name] was deleted at: ' | translate: { name: timesheet.RateCard?.name } }}
                {{ timesheet.RateCard?.deleted_date | localeDate: 'short' }}
              </ng-container>
            }
          </div>
          <div>
            @if (
              (timesheet.overtimeHour && timesheet.overtimeHour !== 0) ||
              (timesheet.overtimeMinutes && timesheet.overtimeMinutes !== 0)
            ) {
              {{ 'Overtime' | translate }}: {{ timesheet.overtimeHour }}h {{ timesheet.overtimeMinutes }}m
            }
          </div>
        </ng-template>
        <a
          sb-icon-button
          [color]="timesheet.RateCard?.deleted ? 'red' : 'transparent'"
          [attr.aria-label]="(timesheet.RateCard?.deleted ? 'Surcharges, rate card deleted' : 'Surcharges') | translate"
          [sbTooltip]="surchargeTooltip"
          [routerLink]="['', { outlets: { modal: ['rates', timesheet.id] } }]"
        >
          <sb-icon name="flag-4-regular" />
        </a>
      }
    </ng-container>
  </div>
</div>
